import Vue from "vue";
import { authBasicHeader, noTenant } from "./AuthHeader";
import { env } from "../config/env";

const apiUrl = env.AUTH_API_URL;
const resetPassUrl = apiUrl + "/reset-senha";

class AuthService {
  clientId = env.AUTH_API_CLIENT;
  secret = env.AUTH_API_SECRET;

  login(user) {
    const formData = new FormData();
    formData.append("username", user.username);
    formData.append("password", user.password);
    formData.append("grant_type", "password");

    return Vue.prototype.$axios.post(apiUrl + "/oauth/token", formData, {
      headers: {
        ...authBasicHeader(this.clientId, this.secret),
        ...noTenant()
      },
      withCredentials: true
    });
  }

  requestPasswordChange(cpf) {
    return Vue.prototype.$axios.post(resetPassUrl, { cpf }, {
      headers: {
        ...noTenant()
      }
    });
  }

  passwordChange(token, novaSenha) {
    return Vue.prototype.$axios.post(
      resetPassUrl + `/${token}`,
      { novaSenha },
      {
        headers: noTenant()
      }
    );
  }

  refreshToken() {
    if(!window.location.href.toLowerCase().includes('callcenter')){
      const formData = new FormData();
      formData.append("grant_type", "refresh_token");

      return Vue.prototype.$axios.post(apiUrl + "/oauth/token", formData, {
        headers: {
          ...authBasicHeader(this.clientId, this.secret),
          ...noTenant()
        },
        withCredentials: true
      });
    } else {
      return Promise.reject(new Error('Refresh token not supported in callcenter context'))
    }
  }

  logout() {
    return Vue.prototype.$axios.delete(apiUrl + "/logout/revoke", {
      headers: noTenant(),
      withCredentials: true
    });
  }
}

export default new AuthService();
